/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Forms_PcInputs */

const en_pc_cmp_r_forms_pc = /** @type {(inputs: Pc_Cmp_R_Forms_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill and author AcroForms with sandboxed JavaScript. Full XFA not yet`)
};

const zh_pc_cmp_r_forms_pc = /** @type {(inputs: Pc_Cmp_R_Forms_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`填写与制作 AcroForm，支持沙箱化 JavaScript，XFA 尚未完全支持`)
};

/**
* | output |
* | --- |
* | "Fill and author AcroForms with sandboxed JavaScript. Full XFA not yet" |
*
* @param {Pc_Cmp_R_Forms_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_forms_pc = /** @type {((inputs?: Pc_Cmp_R_Forms_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Forms_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_forms_pc(inputs)
	return zh_pc_cmp_r_forms_pc(inputs)
});
export { pc_cmp_r_forms_pc as "pc.cmp.r.forms.pc" }